/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ service: NonNullable<unknown> }} Directory_Title_NearInputs */

const en_directory_title_near = /** @type {(inputs: Directory_Title_NearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.service} near you`)
};

const pl_directory_title_near = /** @type {(inputs: Directory_Title_NearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.service} w pobliżu`)
};

/**
* | output |
* | --- |
* | "{service} near you" |
*
* @param {Directory_Title_NearInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_title_near = /** @type {((inputs: Directory_Title_NearInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Title_NearInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_title_near(inputs)
	return en_directory_title_near(inputs)
});